<template>
    <div class="history-audit">
          <Timeline>
            <template v-for="item in trackArr">
              <TimelineItem :key="item.id" class="line-gray" v-if="!item.children">
                <Icon
                  v-if="item.taskStatus == 2"
                  slot="dot"
                  type="md-checkmark-circle"
                  size="26"
                  color="#19be6b"
                />
                <Icon
                  v-if="item.taskStatus == 1"
                  slot="dot"
                  type="md-radio-button-off"
                  size="26"
                  color="#19be6b"
                />
                <Icon
                  v-if="item.taskStatus == 0"
                  slot="dot"
                  type="ios-radio-button-off"
                  size="24"
                  color="#dae1ec"
                />
                <div class="oper-container">
                  <p class="task-container">
                    <span class="task-title">{{item.taskName}}</span>
                    <span>
                      <template v-if="item.isApprove == 1">
                        <span class="success">同意</span>
                      </template>
                      <template v-if="item.isApprove == 2">
                        <span class="error">不同意</span>
                      </template>
                      <template v-if="item.isApprove == 3">
                        <span class="warning">退回</span>
                      </template>
                      <template v-if="item.isApprove == 4">
                        <span class="primary">委派</span>
                      </template>
                      <template v-if="item.isApprove == 5">
                        <span class="success">同意</span>
                      </template>
                      <template v-if="item.isApprove == 6">
                        <span class="error">不同意</span>
                      </template>
                    </span>
                  </p>
                  <div class="task-oper">
                    <template v-if="item.taskStatus == 1">
                      <modify-approve-user
                        ref="modifyApproveUser"
                        :actInstId="actInstId"
                        :complete="callbackSuccess"
                        :extraOrgId="extraOrgId"
                        :extraRegId="extraRegId"
                        :extraCityId="extraCityId"
                        :error="testErr"
                        v-if="showModifyBtn"
                      >
                        <Button slot="func" size="small" type="primary" class="slot-button">{{modifyBtnText}}</Button>
                      </modify-approve-user>
                    </template>
                    <Button type="error" v-if="item.revokeNodeId && showRevokeBtn" size="small" @click="revoke(item.preTaskId,item.preIsBeginTask)" style="margin-left:5px" class="back-button" :loading="loading">撤回</Button>
                  </div>
                </div>
                <div class="content">
                  <template v-if="item.isApprove">

                    <p class="padding-btm-10">
                      <Row class="row-container">
                        <Col span="5" class="row-col-title">
                          <span>处理人:</span>
                        </Col>
                        <Col span="19" class="row-col-content">
                          <Tooltip max-width="400" :content="item.executeUserName" placement="top">
                            <span>{{item.executeUserName}}</span>
                          </Tooltip>
                        </Col>
                      </Row>
                    </p>
                    <p class="padding-btm-10" v-if="item.approvalContent">
                      <Row class="row-container">
                        <Col span="5" class="row-col-title">
                          <span>处理意见:</span>
                        </Col>
                        <Col span="19" class="row-col-content">
                          <Tooltip max-width="400" placement="top" theme="light" :content="item.approvalContent">
                            <span
                            >{{item.approvalContent}}</span>
                          </Tooltip>
                        </Col>
                      </Row>
                    </p>
                    <p class="padding-btm-10">
                      <Row class="row-container">
                        <Col span="5" class="row-col-title">
                          <span>处理时间:</span>
                        </Col>
                        <Col span="19" class="row-col-content">
                          <span>{{item.endTime | dateFormat}}</span>
                        </Col>
                      </Row>
                    </p>
                  </template>

                  <template v-else>
                    <p class="padding-btm-10">
                       <Row class="row-container">
                        <Col span="5" class="row-col-title">
                          <span>处理状态:</span>
                        </Col>
                        <Col span="19" class="row-col-content">
                          <template v-if="item.taskStatus == 1">
                            <span>处理中</span>
                          </template>
                          <template v-if="item.taskStatus == 0">
                            <span>未处理</span>
                          </template>
                        </Col>
                      </Row>
                    </p>
                    <p class="padding-btm-10" v-if="item.nodeUser">
                      <Row>
                        <Col span="5" class="row-col-title">
                          <span>处理人:</span>
                        </Col>
                        <Col span="19" class="row-col-content">
                          <template>
                            <Tooltip max-width="400" :content="item.nodeUser" placement="top">
                              <span>{{item.nodeUser}}</span>
                            </Tooltip>
                          </template>
                        </Col>
                      </Row>
                    </p>
                  </template>
                </div>
              </TimelineItem>
              <TimelineItem :key="item.parentNodeId" class="line-gray" v-else>
                <div class="task-container" style="display: flex;z-index: 999;position: relative;">
                <span :class="['task-title',ele.active?'task-title-active':''] " style="cursor: pointer;margin-right:16px" @click="changeTab(ele)" v-for="ele in item.children" :key="ele.taskId" :label="ele.taskName" :name="ele.taskId">
                  {{ ele.taskName }}
                </span></div>
                <div>
                <div  style="display: flex;margin-top: -40px;">
                <div v-for="ele in item.children" :key="ele.taskId" :label="ele.taskName" :name="ele.taskId" >
                  <div v-if="ele.active">
                    <Icon class="customIcon"
                  v-if="ele.taskStatus == 2"
                  slot="dot"
                  type="md-checkmark-circle"
                  size="26"
                  color="#19be6b"
                />
                <Icon class="customIcon"
                  v-if="ele.taskStatus == 1"
                  slot="dot"
                  type="md-radio-button-off"
                  size="26"
                  color="#19be6b"
                />
                <Icon class="customIcon"
                  v-if="ele.taskStatus == 0"
                  slot="dot"
                  type="ios-radio-button-off"
                  size="24"
                  color="#dae1ec"
                />
                <div class="oper-container">
                  <p class="task-container">
                    <!-- <span class="task-title">{{ele.taskName}}</span> -->
                    <span>
                      <template v-if="ele.isApprove == 1">
                        <span class="success">同意</span>
                      </template>
                      <template v-if="ele.isApprove == 2">
                        <span class="error">不同意</span>
                      </template>
                      <template v-if="ele.isApprove == 3">
                        <span class="warning">退回</span>
                      </template>
                      <template v-if="ele.isApprove == 4">
                        <span class="primary">委派</span>
                      </template>
                      <template v-if="ele.isApprove == 5">
                        <span class="success">同意</span>
                      </template>
                      <template v-if="ele.isApprove == 6">
                        <span class="error">不同意</span>
                      </template>
                    </span>
                  </p>
                  <div class="task-oper">
                    <template v-if="ele.taskStatus == 1">
                      <modify-approve-user
                        ref="modifyApproveUser"
                        :actInstId="actInstId"
                        :complete="callbackSuccess"
                        :extraOrgId="extraOrgId"
                        :extraRegId="extraRegId"
                        :extraCityId="extraCityId"
                        :error="testErr"
                        v-if="showModifyBtn"
                      >
                        <Button slot="func" size="small" type="primary" class="slot-button">{{modifyBtnText}}</Button>
                      </modify-approve-user>
                    </template>
                    <Button type="error" v-if="ele.revokeNodeId && showRevokeBtn" size="small" @click="revoke(ele.preTaskId,ele.preIsBeginTask)" style="margin-left:5px" class="back-button" :loading="loading">撤回</Button>
                  </div>
                </div>
                <div class="content">
                  <template v-if="ele.isApprove">

                    <p class="padding-btm-10">
                      <Row class="row-container">
                        <Col span="5" class="row-col-title">
                          <span>处理人:</span>
                        </Col>
                        <Col span="19" class="row-col-content">
                          <Tooltip max-width="400" :content="ele.executeUserName" placement="top">
                            <span>{{ele.executeUserName}}</span>
                          </Tooltip>
                        </Col>
                      </Row>
                    </p>
                    <p class="padding-btm-10" v-if="ele.approvalContent">
                      <Row class="row-container">
                        <Col span="5" class="row-col-title">
                          <span>处理意见:</span>
                        </Col>
                        <Col span="19" class="row-col-content">
                          <Tooltip max-width="400" placement="top" theme="light" :content="ele.approvalContent">
                            <span
                            >{{ele.approvalContent}}</span>
                          </Tooltip>
                        </Col>
                      </Row>
                    </p>
                    <p class="padding-btm-10">
                      <Row class="row-container">
                        <Col span="5" class="row-col-title">
                          <span>处理时间:</span>
                        </Col>
                        <Col span="19" class="row-col-content">
                          <span>{{ele.endTime | dateFormat}}</span>
                        </Col>
                      </Row>
                    </p>
                  </template>

                  <template v-else>
                    <p class="padding-btm-10">
                       <Row class="row-container">
                        <Col span="5" class="row-col-title">
                          <span>处理状态:</span>
                        </Col>
                        <Col span="19" class="row-col-content">
                          <template v-if="ele.taskStatus == 1">
                            <span>处理中</span>
                          </template>
                          <template v-if="ele.taskStatus == 0">
                            <span>未处理</span>
                          </template>
                        </Col>
                      </Row>
                    </p>
                    <p class="padding-btm-10" v-if="ele.nodeUser">
                      <Row>
                        <Col span="5" class="row-col-title">
                          <span>处理人:</span>
                        </Col>
                        <Col span="19" class="row-col-content">
                          <template>
                            <Tooltip max-width="400" :content="ele.nodeUser" placement="top">
                              <span>{{ele.nodeUser}}</span>
                            </Tooltip>
                          </template>
                        </Col>
                      </Row>
                    </p>
                  </template>
                </div>
                  </div>
                </div>
              
              </div>
                </div>
              </TimelineItem>
            </template>
          </Timeline>
        </div>
</template>

<script>
  // import modifyApproveUser from '../../bpm/approval/modify-approve-user.vue' // 测试
  import { modifyApproveUser } from "sd-modify-approve-user"
import track from '../mixins/track-methods'

export default {
  components: {
    modifyApproveUser
  },
  mixins: [track],
  props: {

  },
  data () {
    return {

    }
  },
  filters: {
    dateFormat: function (dateStr) {
      var date = new Date(dateStr)
      var year = date.getFullYear()
      /* 在日期格式中，月份是从0开始的，因此要加0使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05 */
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hours =
        date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // 拼接
      return (
        year +
        '-' +
        month +
        '-' +
        day +
        ' ' +
        hours +
        ':' +
        minutes +
        ':' +
        seconds
      )
    }
  },
  mounted () {
    this.getApprovalTrack()
  },
  methods: {
    callbackSuccess (data) {
      if (this.modifyUserCallback) {
        this.getApprovalTrack()
        return this.modifyUserCallback(data)
      }else {
        // 重新获取审批历史
        return new Promise((resolve, reject) => {
          let that = this
          this.getApprovalTrack()
          setTimeout(function () {
            that.$Modal.success({
              title: '温馨提示',
              content: '修改审批人成功'
            })
            resolve({ success: true })
          }, 1000)
        })
      }
    },
    testErr () {
      return new Promise((resolve, reject) => {
        let that = this
        setTimeout(function () {
          that.$Modal.error({
            title: '温馨提示',
            content: '修改审批人失败，请稍后重试'
          })
          resolve({ success: false })
        }, 1000)
      })
    }
  }
}
</script>
<style scoped>
  .history-audit {
    padding: 15px;
  }
  .task-container {
    margin-bottom: 10px;
  }
  .task-container .task-title {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
  }
  .line-gray {
    padding: 0;
  }
  .history-audit .content {
    width: 432px;
    padding: 10px 18px;
    background-color: #F5F8FF;
  }
  /deep/ .ivu-timeline-item-content {
    padding: 10px 10px 10px 24px;
    top: -16px;
  }
  .row-col-title {
    text-align: right;
  }
  .row-col-title span {
    font-size: 16px;
    color: #7A8499;
  }

  .padding-btm-10 {
    padding: 5px 0;
  }

  .row-col-content {
    padding-left: 10px;
  }
  .row-col-content span {
    color: #333333;
    font-size: 16px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    /* autoprefixer: ignore next */
    -webkit-box-orient: vertical;
  }
  .success {
    padding: 4px;
    background-color: #D9FCE8;
    color: #13BA5A;
    margin-left: 10px;
  }
  .error {
    padding: 4px;
    background-color: #FFD6DD;
    color: #F23051;
    margin-left: 10px;
  }
  .warning {
    padding: 4px;
    background-color: #FFE7D6;
    color: #FF8833;
    margin-left: 10px;
  }
  .primary {
    padding: 4px;
    background-color: #E5F0FF;
    color: #2B5FDA;
    margin-left: 10px;
  }
  .task-oper {
    float: right;
  }
  .history-audit .oper-container {
    width: 432px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }

  .slot-button {
    background-color: #2B5FDA;
    color: #FFFFFF;
    font-size: 14px;
  }

  .back-button {
    background-color: #F36279;
    color: #FFFFFF;
    font-size: 14px;
  }
  /deep/ .ivu-icon-ios-radio-button-off {
    background-color: #DAE1EC;
    border-radius: 50%;
  }
  .customIcon{
    position: relative;
    left: -31px;
    top: 0px;
    background: #fff;
  }
  .task-title-active{
    border-bottom: 2px solid #2B5FDA;
  }
</style>



// WEBPACK FOOTER //
// src/component/flow-general-history/components/flow-general-history.vue